var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashUsers = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.181,
    height: 33.903,
    viewBox: "0 0 36.181 33.903",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(-1167 -289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(1013.339 -148.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M189.839,471.662c.008-.245.155-6.054-3.5-9.4a1.012,1.012,0,0,0-1.291-.058c-.162.123-4.011,2.973-7.647.011a1.007,1.007,0,0,0-1.3.021,8.829,8.829,0,0,0-1.11,1.25,12.423,12.423,0,0,0-2.038-2.425,1.007,1.007,0,0,0-1.291-.058c-.242.185-6,4.467-11.477.007a1.006,1.006,0,0,0-1.3.021c-.208.181-5.108,4.536-5.23,13.109a1.008,1.008,0,0,0,1.007,1.021l22.153,0a1.006,1.006,0,0,0,1.006-.974c0-.086.018-.658-.04-1.54l11.046,0A1.006,1.006,0,0,0,189.839,471.662Zm-34.125,1.479a16.839,16.839,0,0,1,3.941-10.016c5.232,3.646,10.569,1.115,12.488-.039,2.969,3.19,3.543,8.007,3.649,10.053Zm21.849-2.517a20.151,20.151,0,0,0-1.49-5.157,9.747,9.747,0,0,1,.811-1.142,8.185,8.185,0,0,0,8.632-.023,11.317,11.317,0,0,1,2.275,6.321Z",
    transform: "translate(0 -3.721)",
    fill: "#119c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M181.588,458.472h0a6.928,6.928,0,1,0-4.9-11.823,6.962,6.962,0,0,0-1.016,1.3c.031-.311.047-.626.047-.942a9.479,9.479,0,1,0-9.48,9.481h0a9.406,9.406,0,0,0,6.7-2.78,9.5,9.5,0,0,0,1.729-2.371c0,.071-.011.139-.011.21A6.938,6.938,0,0,0,181.588,458.472Zm-3.473-10.4a4.911,4.911,0,1,1,3.476,8.385h0a4.911,4.911,0,0,1-3.473-8.385Zm-6.6,4.212a7.4,7.4,0,0,1-5.273,2.19h0a7.476,7.476,0,1,1,5.276-2.19Z",
    transform: "translate(-0.496)",
    fill: "#119c4a"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dash_users.6ebea507.svg";
export { ForwardRef as ReactComponent };